import { useFeatureForUser } from '@/lib/features';
import useUserDetails from '@/shared/data/useUserDetails';
import { isProd } from '@/utils/env';

// 'center' (srm.center__c) is more granular than 'team' — one team can map to multiple geo centers.
// Full known center list: AUS-ESRM, AUS-MKT, AUS-SBT, AUS-SRM, CHN-ESRM, CHN-MKT, CHN-SBT, CHN-SRM,
//   GBR-ESRM, GBR-MKT, GBR-SBT, GBR-SRM, IND-ESRM, IND-MKT, IND-PV, IND-SBT, IND-SRM,
//   LATAM-MKT, MEX-SRM, NOT-SET, TWN-ESRM, USA-DSF, USA-ESRM, USA-MKT, USA-SBT, USA-SRM
const FINANCE_IQ_CENTERS = [
  'USA-MKT',
  'USA-DSF',
  'USA-SRM',
  'USA-ESRM',
  'USA-SBT',
  'GBR-ESRM',
  'GBR-MKT',
  'GBR-SBT',
  'GBR-SRM',
] as const;

export const useFinanceIqEnabled = (): boolean => {
  const [enableFinanceIQ] = useFeatureForUser('enterprise-ui_enableFinanceIQ');
  const { data: center } = useUserDetails((userDetails) => userDetails.me?.account?.srm?.center);
  const isProdEnv = isProd();

  if (!isProdEnv && enableFinanceIQ) {
    return true;
  }

  const isFinanceIqCenter = typeof center === 'string' && (FINANCE_IQ_CENTERS as readonly string[]).includes(center);

  return enableFinanceIQ && isFinanceIqCenter;
};
